import { useTheme } from "@emotion/react";
import {
  ApartmentOutlined,
  AttachFileOutlined,
  CheckBox,
  CheckBoxOutlineBlank,
  LocalOfferOutlined,
  ManageAccountsOutlined,
} from "@mui/icons-material";
import {
  Autocomplete,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { IMaskInput } from "react-imask";
import { FixedSizeList } from "react-window";
import api from "../../../services/api";
import InfoPopover from "../../infoPopover";
import MentionTextField from "../../textfieldMention";
import FileDropzone from "../../uploadAnexo/fileDropzone";
import VirtualizedAutocomplete from "../../virtualization/virtualizedAutocomplete";
import { CampoCliente, renderOpcaoCliente } from "../../opcaoCliente";
import { getClienteOptionLabel } from "../../grupoEconomico/helpers";
import useStyles from "./styles";
import { getErpPrincipal } from "../../../services/erpSistema";

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={[{ mask: "(00) 0000-0000" }, { mask: "(00) 00000-0000" }]}
      inputRef={ref}
      onAccept={(value, mask) => {
        onChange({ target: { name: props.name, value: mask.unmaskedValue } });
      }}
      overwrite
    />
  );
});

export default function EditTicketComponent(params) {
  const {
    clientes = [],
    loadingServicos = false,
    loadingCreateTicket = false,
    loadingParams = false,
    setServicos = () => {},
    servicos = [],
    setDataTicket = () => {},
    dataTicket = {},
    error = false,
    statusAtendimento = [],
    tipoAtendimento = [],
    origemContato = [],
    usuariosSelecionados = [],
    setUsuariosSelecionados = () => {},
    etapasFluxoAtendimento = [],
    userResponsaveis = [],
    isEdit = false,
    motivoFechamento = [],
    setDataTicketParamsFechamento = () => {},
    dataTicketParamsFechamento = {},
    isAddAnexo = false,
    files = [],
    setFiles = () => {},
    tecnicos = [],
    tipoOs = [],
    statusOs = [],
    disponibilidade = [],
    agenda = [],
    setParamsAberturaOs = () => {},
    paramsAberturaOs = {},
    disponibilidadeSelecionada = [],
    setDisponibilidadeSelecionada = () => {},
    setTecnicosSelecionados = () => {},
    tecnicosSelecionados = [],
    prioridade = [],
    setStartDate = () => {},
    setEndDate = () => {},
    startDate = null,
    endDate = null,
    setTipoAgendamento = () => {},
    tipoAgendamento = "manual",
    configPermissao = false,
    dataForms = [],
    forms = {},
    setForms = () => {},
    // ERP escolhido na tela (tipo e id); sem eles, a variável do front.
    erp: erpProp,
    erpId,
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);
  const [agendaOsAutomatico, setAgendaOsAutomatico] = useState([]);
  const [horaSelecionada, setHoraSelecionada] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [dataSelecionada, setDataSelecionada] = useState("");
  const [datasOsAutomatica, setDatasOsAutomatica] = useState([]);
  const [loadingAgenda, setLoadingAgenda] = useState(false);
  const [open, setOpen] = useState(false);
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;
  // O estado guarda só o clienteErpId; o objeto completo é usado em dois
  // lugares do autocomplete — como `value` e para montar o selo do campo.
  const clienteSelecionado =
    clientes.find(
      (c) =>
        c.clienteErpId === dataTicket?.clienteErpId &&
        (!erpId || c.erpId === erpId),
    ) || null;
  const [dragActive, setDragActive] = useState(false);
  const erp = erpProp || getErpPrincipal();
  const configErp = (invertInfo) => {
    switch (erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };

  useEffect(() => {
    const handlePaste = (event) => {
      // Verifica se existe algo na área de transferência
      if (event.clipboardData && event.clipboardData.items) {
        const items = event.clipboardData.items;
        const pastedFiles = [];

        // Itera sobre os itens colados
        for (let i = 0; i < items.length; i++) {
          // Se o item for um arquivo (ex: imagem de print)
          if (items[i].kind === "file") {
            const file = items[i].getAsFile();

            // Renomear o arquivo para evitar nomes genéricos como "image.png"

            if (file) {
              const newFile = new File(
                [file],
                `print_${new Date().getTime()}.png`,
                { type: file.type },
              );
              pastedFiles.push(newFile);
            }
          }
        }

        // Se houver arquivos válidos, adiciona ao state
        if (pastedFiles.length > 0) {
          event.preventDefault(); // Evita comportamento padrão se houver arquivo
          addFiles(pastedFiles);
        }
      }
    };

    // Adiciona o ouvinte no documento inteiro quando o componente monta
    document.addEventListener("paste", handlePaste);

    // Remove o ouvinte quando o componente desmonta
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []);

  useEffect(() => {
    if (!configPermissao) return;
    setForms({});
  }, [configPermissao, dataTicket?.tipoAtendimentoId]);

  useEffect(() => {
    const now = dayjs();
    const datesAreValid =
      startDate &&
      dayjs(startDate).isValid() &&
      endDate &&
      dayjs(endDate).isValid();

    if (datesAreValid) {
      const isStartAfterNow =
        dayjs(startDate).isAfter(now) || dayjs(startDate).isSame(now, "minute");
      const isEndDateAfterStart = dayjs(endDate).isAfter(dayjs(startDate));
      const isWithin24Hours =
        dayjs(endDate).isBefore(dayjs(startDate).add(24, "hour")) ||
        dayjs(endDate).isSame(dayjs(startDate).add(24, "hour"));

      // Adicionado isStartAfterNow na condição
      if (isStartAfterNow && isEndDateAfterStart && isWithin24Hours) {
        setParamsAberturaOs((prev) => ({
          ...prev,
          data_inicio_programado: dayjs(startDate).format("YYYY-MM-DD"),
          data_termino_programado: dayjs(endDate).format("YYYY-MM-DD"),
          hora_inicio_programado: dayjs(startDate).format("HH:mm:ss"),
          hora_termino_programado: dayjs(endDate).format("HH:mm:ss"),
        }));
      } else {
        // Limpa os parâmetros se a data de início for retroativa
        setParamsAberturaOs((prev) => ({
          ...prev,
          data_inicio_programado: null,
          data_termino_programado: null,
          hora_inicio_programado: null,
          hora_termino_programado: null,
        }));
      }
    } else {
      // ... restante da sua lógica de limpeza
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (tipoAgendamento === "automatico") {
      setStartDate(null);
      setEndDate(null);

      setParamsAberturaOs((prev) => ({
        ...prev,
        statusOs: "pendente",
        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        agenda: { id: null, descricao: null },
        tecnicos: [],
      }));
    } else {
      setParamsAberturaOs((prev) => ({
        ...prev,
        statusOs: "",
        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        agenda: { id: null, descricao: null },
        tecnicos: [],
      }));

      setTecnicosSelecionados([]);
      setDataSelecionada("");
      setHoraSelecionada("");
    }
  }, [tipoAgendamento]);

  useEffect(() => {
    if (tipoAgendamento === "automatico") {
      setParamsAberturaOs((prev) => ({
        ...prev,

        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        agenda: { id: null, descricao: null },
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);
      setDataSelecionada("");
      setHoraSelecionada("");
    }
  }, [paramsAberturaOs?.tipoOs?.id, dataTicket?.clienteServicoId]);

  /* ################################################################################################# */
  useEffect(() => {
    const controller = new AbortController();

    if (
      paramsAberturaOs?.tipoOs?.id &&
      dataTicket?.clienteServicoId &&
      tipoAgendamento === "automatico"
    ) {
      getAgendaOsAutomatico(controller.signal);
    }

    return () => {
      controller.abort();
    };
  }, [
    paramsAberturaOs?.tipoOs?.id,
    dataTicket?.clienteServicoId,
    tipoAgendamento,
  ]);

  useEffect(() => {
    const controller = new AbortController();

    if (
      paramsAberturaOs?.agenda?.id &&
      paramsAberturaOs?.tipoOs?.id &&
      dataTicket?.clienteServicoId &&
      tipoAgendamento === "automatico"
    ) {
      getHorariosDisponiveis(controller.signal);
    }

    return () => {
      controller.abort();
    };
  }, [
    paramsAberturaOs?.agenda?.id,
    paramsAberturaOs?.tipoOs?.id,
    dataTicket?.clienteServicoId,
  ]);

  useEffect(() => {
    if (tipoAgendamento === "automatico" && paramsAberturaOs?.agenda?.id) {
      setParamsAberturaOs((prev) => ({
        ...prev,

        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);
      setDataSelecionada("");
      setHoraSelecionada("");
    }
  }, [paramsAberturaOs?.agenda?.id]);
  useEffect(() => {
    if (
      tipoAgendamento === "automatico" &&
      paramsAberturaOs?.data_inicio_programado
    ) {
      setParamsAberturaOs((prev) => ({
        ...prev,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);

      setHoraSelecionada("");
    }
  }, [paramsAberturaOs?.data_inicio_programado]);
  useEffect(() => {
    if (
      tipoAgendamento === "automatico" &&
      paramsAberturaOs?.hora_inicio_programado
    ) {
      setParamsAberturaOs((prev) => ({
        ...prev,
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);
    }
  }, [paramsAberturaOs?.hora_inicio_programado]);
  /* ################################################################################################# */
  const handleChangeDataOs = (event) => {
    const objectData = event.target.value;

    // Atualiza o estado com o objeto inteiro
    setDataSelecionada(objectData);
    setParamsAberturaOs((prev) => ({
      ...prev,
      data_inicio_programado: objectData.data,
      data_termino_programado: objectData.data,
    }));
  };

  const handleChangeHorarioOs = (event) => {
    const objectHorario = event.target.value;

    // Atualiza o estado com o objeto inteiro
    setHoraSelecionada(objectHorario);
    setParamsAberturaOs((prev) => ({
      ...prev,
      hora_inicio_programado: objectHorario.hora_inicio,
      hora_termino_programado: objectHorario.hora_termino,
    }));
  };
  const getAgendaOsAutomatico = async (signal) => {
    setLoadingAgenda(true);
    try {
      const response = await api.post(
        "/interno/find/agendaOsAutomatica",
        {
          idTipoOs: paramsAberturaOs?.tipoOs?.id,
          idClienteServico: dataTicket?.clienteServicoId,
          erpId,
        },
        { signal },
      );

      setAgendaOsAutomatico(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal?.aborted) {
        setLoadingAgenda(false);
      }
    }
  };

  const getHorariosDisponiveis = async (signal) => {
    setLoadingData(true);
    try {
      const response = await api.post(
        "/interno/find/horariosDisponiveisAgenda",
        {
          idAgenda: paramsAberturaOs?.agenda?.id,
          idTipoOs: paramsAberturaOs?.tipoOs?.id,
          idClienteServico: dataTicket?.clienteServicoId,
          erpId,
        },
        { signal },
      );
      setDatasOsAutomatica(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal?.aborted) {
        setLoadingData(false);
      }
    }
  };

  const verificationCamposOsAutomatico = () => {
    if (tipoAgendamento === "automatico") {
      const verification = {
        disabledAgenda: !paramsAberturaOs?.tipoOs?.id ? true : false,
        disabledTecnicos: !paramsAberturaOs?.hora_inicio_programado
          ? true
          : false,

        disabledData: !paramsAberturaOs?.agenda?.id ? true : false,
        disabledHorario: !paramsAberturaOs?.data_inicio_programado
          ? true
          : false,
        agenda: agendaOsAutomatico || [],
        tecnicos: horaSelecionada?.tecnicos || [],
      };

      return verification;
    } else {
      return {
        disabledAgenda: false,
        disabledTecnicos: false,
        agenda: agenda,
        tecnicos: tecnicos,
      };
    }
  };

  // Drag & Drop
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };
  const handleDragLeave = () => {
    setDragActive(false);
  };
  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);
    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      addFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  };

  const handleFileChange = (event) => {
    addFiles(event.target.files);
  };
  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const addFiles = (novosArquivos) => {
    setFiles((prev) => [...prev, ...Array.from(novosArquivos)]);
  };

  const maskTelefone = (value = "") => {
    const numbers = value.replace(/\D/g, "");

    if (numbers.length <= 10) {
      // Fixo
      return numbers.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    }

    // Celular
    return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
  };

  function formatarNome(nome) {
    if (!nome) return "";

    return nome
      .toLowerCase() // tudo minúsculo
      .replace(/_/g, " ") // troca underscore por espaço
      .replace(/\s+/g, " ") // remove espaços extras
      .trim() // remove espaços no início/fim
      .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase()); // primeira letra de cada palavra maiúscula
  }
  const optionsOriginal = verificationCamposOsAutomatico()?.tecnicos || [];
  const allSelected =
    optionsOriginal?.length > 0 &&
    tecnicosSelecionados?.length === optionsOriginal?.length;
  // Adiciona a opção "Selecionar Todos" no topo da lista de opções
  const autocompleteOptions =
    optionsOriginal?.length > 0
      ? [
          { id: "select-all", name: "Selecionar Todos", isSelectAll: true },
          ...optionsOriginal,
        ]
      : [];
  const ListboxComponent = React.forwardRef(
    function ListboxComponent(props, ref) {
      const { children, ...other } = props;
      const itemData = React.Children.toArray(children);
      const itemCount = itemData.length;
      const itemSize = 56; // Altura aproximada de cada linha (li) em pixels

      return (
        <div ref={ref} {...other}>
          <FixedSizeList
            height={250} // Altura máxima da caixinha do menu suspenso
            width="100%"
            itemSize={itemSize}
            itemCount={itemCount}
            outerElementType={React.forwardRef((props, ref) => (
              <div ref={ref} {...props} />
            ))}
            innerElementType="ul"
            itemData={itemData}
          >
            {({ data, index, style }) => {
              // Aplica o posicionamento absoluto necessário pela virtualização na linha do MUI
              return React.cloneElement(data[index], {
                style: {
                  ...style,
                  ...data[index].props.style,
                  margin: 0,
                  boxSizing: "border-box",
                },
              });
            }}
          </FixedSizeList>
        </div>
      );
    },
  );
  return (
    <Paper
      variant="outlined"
      sx={{
        height: "79%",
        borderRadius: "16px",
        p: 0.8,
        position: "relative",
        overflow: "hidden",
        backgroundColor:
          theme.palette.mode === "dark"
            ? alpha(theme.palette.colors.black.dark, 0.4)
            : theme.palette.colors.black.lighter,
      }}
    >
      <Box sx={styles.paperItens}>
        <Grid
          container
          spacing={2}
          columns={{
            xs: 6,
            sm: 6,
            smx: 6,
            md: 6,
            lg: 6,
            xl: 6,
            xxl: 6,
          }}
        >
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ApartmentOutlined sx={{ color: theme.palette.primary.main }} />
              <Typography sx={{ fontWeight: "bold" }}>
                Dados cadastrais
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            {isEdit ? (
              <TextField
                disabled
                variant="filled"
                size="small"
                label="Cliente"
                value={dataTicket?.nome || ""}
                sx={{ width: "100%" }}
              />
            ) : (
              <VirtualizedAutocomplete
                size="small"
                options={clientes}
                disabled={loadingServicos || loadingCreateTicket}
                value={clienteSelecionado}
                // Garante a comparação correta entre a opção e o valor selecionado
                isOptionEqualToValue={(option, value) =>
                  option.clienteErpId === value.clienteErpId
                }
                getOptionLabel={(option) => getClienteOptionLabel(option)}
                onChange={(event, value) => {
                  if (!value) {
                    setServicos([]);
                    setDataTicket((prev) => ({
                      ...prev, // Mantém os outros campos
                      clienteErpId: null,
                      cnpj: null,
                      nome: null,
                    }));
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    clienteErpId: value.clienteErpId || null,
                    cnpj: value.cnpj || null,
                    nome: value.nome || null,
                  }));
                }}
                sx={{ width: "100%" }}
                renderOption={renderOpcaoCliente()}
                renderInput={(params) => (
                  <CampoCliente
                    params={params}
                    option={clienteSelecionado}
                    variant="filled"
                    error={error && !dataTicket?.clienteErpId}
                    helperText={
                      error && !dataTicket?.clienteErpId && "Campo obrigatório"
                    }
                    label="Cliente"
                  />
                )}
              />
            )}
          </Grid>
          <Grid item xs={6} sm={3} md={3}>
            <Box sx={styles.boxTextField}>
              <Autocomplete
                size="small"
                options={servicos}
                disabled={
                  !dataTicket?.cnpj || loadingServicos || loadingCreateTicket
                }
                value={
                  servicos?.find(
                    (servico) =>
                      servico?.id_cliente_servico ===
                      dataTicket?.clienteServicoId,
                  ) || null
                }
                getOptionLabel={(option) =>
                  option
                    ? `${option?.id_cliente_servico} - ${option?.nome || ""}`
                    : ""
                }
                onChange={(event, value) => {
                  if (!value) {
                    setDataTicket((prev) => ({
                      ...prev,
                      clienteServicoId: null,
                      telefone: null,
                      email: null,
                      enderecoInstalacao: null,
                    }));
                    return;
                  }

                  setDataTicket((prev) => ({
                    ...prev,
                    clienteServicoId: value?.id_cliente_servico || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Serviço"
                    error={error && !dataTicket?.clienteServicoId}
                    helperText={
                      error &&
                      !dataTicket?.clienteServicoId &&
                      "Campo obrigatório"
                    }
                  />
                )}
                filterOptions={(options, params) => {
                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia) {
                    return (
                      <li key={key} {...optionProps}>
                        {`${option.id_cliente_servico} - ${option.nome}`}
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={styles.boxLine}>
                        <span style={{ fontWeight: "bold" }}>
                          {`${option.id_cliente_servico} - ${option.nome}`}
                        </span>
                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                {configErp(option?.invertInfo).labelRef}:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
              />

              {loadingServicos && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>

          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              variant="filled"
              label="Telefone de contato"
              disabled={
                !dataTicket?.clienteServicoId || loadingCreateTicket || isEdit
              }
              value={maskTelefone(dataTicket?.telefone || "")}
              onChange={(event) => {
                const cellphoneNumber = event.target.value.replace(/\D/g, "");

                setDataTicket((prev) => ({
                  ...prev,
                  telefone: cellphoneNumber,
                }));
              }}
              error={error && !dataTicket?.telefone}
              helperText={error && !dataTicket?.telefone && "Campo obrigatório"}
            />
          </Grid>
          <Grid item xs={6} sm={3} smx={3} md={3} lg={3} xl={3} xxl={3}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              value={dataTicket?.email || ""}
              variant="filled"
              label="E-mail"
              disabled={
                !dataTicket?.clienteServicoId || loadingCreateTicket || isEdit
              }
              onChange={(event) => {
                setDataTicket((prev) => ({
                  ...prev,
                  email: event.target.value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              variant="filled"
              label="Endereço de instalação"
              value={dataTicket?.enderecoInstalacao || ""}
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Divider />
          </Grid>
          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalOfferOutlined sx={{ color: theme.palette.primary.main }} />
              <Typography sx={{ fontWeight: "bold" }}>
                Dados do ticket
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={6}
            sm={configPermissao ? 6 : 2}
            smx={configPermissao ? 6 : 2}
            md={configPermissao ? 6 : 2}
            lg={configPermissao ? 6 : 2}
            xl={configPermissao ? 6 : 2}
            xxl={configPermissao ? 6 : 2}
          >
            <Box sx={styles.boxTextField}>
              <VirtualizedAutocomplete
                size="small"
                options={tipoAtendimento}
                value={
                  tipoAtendimento?.find(
                    (item) => item?.id === dataTicket?.tipoAtendimentoId,
                  ) || null
                }
                getOptionLabel={(option) =>
                  option ? `${option?.descricao || ""} ` : ""
                }
                disabled={loadingParams || loadingCreateTicket}
                onChange={(event, value) => {
                  setDataTicket((prev) => ({
                    ...prev,
                    tipoAtendimentoId: value?.id || null,
                  }));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{
                  width: "100%",
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    variant="filled"
                    error={error && !dataTicket?.tipoAtendimentoId}
                    helperText={
                      error &&
                      !dataTicket?.tipoAtendimentoId &&
                      "Campo obrigatório"
                    }
                    {...params}
                    label="Tipo de atendimento"
                  />
                )}
              />
              {loadingParams && <LinearProgress sx={styles.linearProgres} />}
            </Box>
          </Grid>
          {!configPermissao && (
            <>
              <Grid item xs={6} sm={2} smx={2} md={2} lg={2} xl={2} xxl={2}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={statusAtendimento}
                    value={
                      statusAtendimento?.find(
                        (item) => item?.id === dataTicket?.statusAtendimentoId,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) =>
                      option ? `${option?.descricao || ""} ` : ""
                    }
                    disabled={loadingParams || loadingCreateTicket}
                    onChange={(event, value) => {
                      setDataTicket((prev) => ({
                        ...prev,
                        statusAtendimentoId: value?.id || null,
                      }));
                    }}
                    sx={{
                      width: "100%",
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        variant="filled"
                        error={error && !dataTicket?.statusAtendimentoId}
                        helperText={
                          error &&
                          !dataTicket?.statusAtendimentoId &&
                          "Campo obrigatório"
                        }
                        {...params}
                        label="Status do atendimento"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
              <Grid item xs={6} sm={2} smx={2} md={2} lg={2} xl={2} xxl={2}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={origemContato}
                    value={
                      origemContato?.find(
                        (item) =>
                          item?.idOrigemContato === dataTicket?.origemContatoId,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.idOrigemContato === value.idOrigemContato
                    }
                    getOptionLabel={(option) =>
                      option ? `${option?.origemContato || ""} ` : ""
                    }
                    onChange={(event, value) => {
                      setDataTicket((prev) => ({
                        ...prev,
                        origemContatoId: value?.idOrigemContato || null,
                      }));
                    }}
                    sx={{
                      width: "100%",
                    }}
                    disabled={loadingParams || loadingCreateTicket}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        variant="filled"
                        error={error && !dataTicket?.origemContatoId}
                        helperText={
                          error &&
                          !dataTicket?.origemContatoId &&
                          "Campo obrigatório"
                        }
                        {...params}
                        label="Origem do contato"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
            </>
          )}

          {/* --- INÍCIO DOS CAMPOS DINÂMICOS DA PERMISSÃO --- */}
          {configPermissao &&
            (() => {
              const atendimentoAtual = dataForms.find(
                (item) =>
                  item.tipoAtendimentoId === dataTicket?.tipoAtendimentoId,
              );

              if (!atendimentoAtual || !atendimentoAtual?.forms) return null;

              const totalItems = atendimentoAtual.forms.length;

              return atendimentoAtual.forms.map((dynamicField, idx) => {
                const fieldKey = dynamicField.name;
                const isTotalOdd = totalItems % 2 !== 0;
                const isLastItem = idx === totalItems - 1;
                const size = isTotalOdd && isLastItem ? 6 : 3;

                return (
                  <Grid
                    key={idx}
                    item
                    xs={6}
                    sm={size}
                    smx={size}
                    md={size}
                    lg={size}
                    xl={size}
                    xxl={size}
                  >
                    <Box sx={styles.boxTextField}>
                      <TextField
                        sx={{ width: "100%" }}
                        size="small"
                        variant="filled"
                        autoComplete="off"
                        label={dynamicField?.name || ""}
                        value={forms?.[fieldKey] || ""}
                        disabled={loadingParams || loadingCreateTicket}
                        onChange={(e) =>
                          setForms((prev) => ({
                            ...prev,
                            [fieldKey]: e.target.value,
                          }))
                        }
                        InputProps={{
                          ...(dynamicField.type === 1
                            ? { inputComponent: TextMaskCustom }
                            : {}),
                          ...(dynamicField?.description
                            ? {
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <InfoPopover
                                      titulo={dynamicField?.name}
                                      descricao={dynamicField.description}
                                      iconSize="small"
                                      sxIcon={{ p: 0 }}
                                    />
                                  </InputAdornment>
                                ),
                              }
                            : {}),
                        }}
                      />
                    </Box>
                  </Grid>
                );
              });
            })()}
          {/* --------------------------------------------------- */}

          <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
            <MentionTextField
              value={dataTicket?.descricaoAbertura || ""}
              onChange={(value) =>
                setDataTicket((prev) => ({
                  ...prev,
                  descricaoAbertura: value,
                }))
              }
              label="Descrição de abertura"
              variant="filled"
              InputProps={{
                inputComponent: "textarea",
              }}
              /*   disabled={loadingCreateTicket || loadingParams} */
              error={
                error &&
                (!dataTicket?.descricaoAbertura ||
                  dataTicket?.descricaoAbertura.length < 10)
              }
              helperText={
                (error &&
                  !dataTicket?.descricaoAbertura &&
                  "Campo obrigatório") ||
                (error &&
                  dataTicket?.descricaoAbertura?.length > 0 &&
                  dataTicket?.descricaoAbertura.length < 10 &&
                  "A descrição deve ter no mínimo 10 caracteres")
              }
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  paddingTop: "25px",
                  paddingRight: "5px",
                  paddingBottom: "5px",
                },
                "& textarea": {
                  resize: "vertical",
                  minHeight: "80px",
                  padding: "10px 12px",
                },
              }}
            />
          </Grid>
          {dataTicket?.statusAtendimentoId === 3 && (
            <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={motivoFechamento}
                    // Acesso direto à propriedade do objeto simples
                    value={
                      motivoFechamento?.find(
                        (item) =>
                          item?.id ===
                          dataTicketParamsFechamento?.id_motivo_fechamento_atendimento,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) =>
                      option ? `${option?.descricao || ""} ` : ""
                    }
                    disabled={loadingParams || loadingCreateTicket}
                    onChange={(event, value) => {
                      setDataTicketParamsFechamento((prev) => ({
                        ...prev,
                        id_motivo_fechamento_atendimento: value?.id || null,
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="filled"
                        label="Motivo do fechamento"
                        error={
                          error &&
                          !dataTicketParamsFechamento?.id_motivo_fechamento_atendimento
                        }
                        helperText={
                          error &&
                          !dataTicketParamsFechamento?.id_motivo_fechamento_atendimento &&
                          "Campo obrigatório"
                        }
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>

                <MentionTextField
                  value={dataTicketParamsFechamento?.descricao_fechamento || ""}
                  disabled={loadingCreateTicket || loadingParams}
                  onChange={(value) =>
                    setDataTicketParamsFechamento((prev) => ({
                      ...prev,
                      descricao_fechamento: value,
                    }))
                  }
                  label="Descrição de fechamento"
                  variant="filled"
                  InputProps={{
                    inputComponent: "textarea",
                  }}
                  /*   disabled={loadingCreateTicket || loadingParams} */
                  error={
                    error &&
                    (!dataTicketParamsFechamento?.descricao_fechamento ||
                      dataTicketParamsFechamento?.descricao_fechamento.length <
                        10)
                  }
                  helperText={
                    error &&
                    (!dataTicketParamsFechamento?.descricao_fechamento
                      ? "Campo obrigatório"
                      : dataTicketParamsFechamento?.descricao_fechamento
                            .length < 10
                        ? "A descrição deve ter no mínimo 10 caracteres"
                        : "")
                  }
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      paddingTop: "25px",
                      paddingRight: "5px",
                      paddingBottom: "5px",
                    },
                    "& textarea": {
                      resize: "vertical",
                      minHeight: "80px",
                      padding: "10px 12px",
                    },
                  }}
                />
              </Box>
            </Grid>
          )}
          {!configPermissao && (
            <>
              <Grid item xs={6} sm={6} smx={4} md={4} lg={4} xl={4} xxl={4}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    multiple
                    limitTags={1}
                    size="small"
                    options={userResponsaveis}
                    disabled={loadingParams || loadingCreateTicket}
                    value={usuariosSelecionados}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    onChange={(event, value) => {
                      setUsuariosSelecionados(value);
                      setDataTicket((prev) => ({
                        ...prev,
                        usuariosResponsaveis: value || [],
                      }));
                      if (!isEdit) {
                        localStorage.setItem(
                          "usuariosResponsaveis",
                          JSON.stringify(value),
                        );
                      }
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          error &&
                          (!usuariosSelecionados ||
                            usuariosSelecionados?.length === 0)
                        }
                        helperText={
                          error &&
                          (!usuariosSelecionados ||
                            usuariosSelecionados?.length === 0) &&
                          "Campo obrigatório"
                        }
                        size="small"
                        variant="filled"
                        label="Usuário responsável"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
              <Grid item xs={6} sm={6} smx={2} md={2} lg={2} xl={2} xxl={2}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={etapasFluxoAtendimento}
                    disabled={loadingParams || loadingCreateTicket}
                    value={
                      etapasFluxoAtendimento.find(
                        (item) =>
                          item.idEtapaFluxoAtendimento ===
                          dataTicket?.idEtapaFluxoAtendimento,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.idEtapaFluxoAtendimento ===
                      value.idEtapaFluxoAtendimento
                    }
                    getOptionLabel={(option) =>
                      option?.etapaFluxoAtendimento || ""
                    }
                    onChange={(event, value) => {
                      setDataTicket((prev) => ({
                        ...prev,
                        idEtapaFluxoAtendimento:
                          value?.idEtapaFluxoAtendimento || "",
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="filled"
                        label="Etapa fluxo atendimento"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
            </>
          )}

          {!isEdit && dataTicket?.statusAtendimentoId === 1 && (
            <>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Divider />
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ManageAccountsOutlined
                    sx={{ color: theme.palette.primary.main }}
                  />
                  <Typography sx={{ fontWeight: "bold" }}>
                    Ordem de serviço
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel
                    component="legend"
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      marginBottom: 1,
                      color: "text.secondary",
                    }}
                  >
                    Tipo de Agendamento
                  </FormLabel>

                  <RadioGroup
                    row
                    aria-label="tipo-agendamento"
                    name="tipoAgendamento"
                    value={tipoAgendamento}
                    onChange={(e) => setTipoAgendamento(e.target.value)}
                    sx={{ gap: 2 }} // Espaçamento elegante entre as opções
                  >
                    {/* Opção: Manual */}
                    <Box
                      sx={{
                        ...styles.boxSelectTipo,
                        borderColor:
                          tipoAgendamento === "manual"
                            ? "primary.main"
                            : "divider",

                        backgroundColor:
                          tipoAgendamento === "manual"
                            ? "action.hover"
                            : "transparent",
                      }}
                    >
                      <FormControlLabel
                        value="manual"
                        control={<Radio size="small" />}
                        label={
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                            >
                              Manual
                            </Typography>
                          </Box>
                        }
                        sx={{ width: "100%", margin: 0 }}
                      />
                    </Box>

                    {/* Opção: Automático */}
                    <Box
                      sx={{
                        ...styles.boxSelectTipo,
                        borderColor:
                          tipoAgendamento === "automatico"
                            ? "primary.main"
                            : "divider",

                        backgroundColor:
                          tipoAgendamento === "automatico"
                            ? "action.hover"
                            : "transparent",
                      }}
                    >
                      <FormControlLabel
                        value="automatico"
                        control={<Radio size="small" />}
                        label={
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 500 }}
                            >
                              Automático
                            </Typography>
                          </Box>
                        }
                        sx={{ width: "100%", margin: 0 }}
                      />
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Divider />
              </Grid>
              <Divider />
              <Grid item xs={6} sm={3} md={3}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={tipoOs}
                    disabled={loadingParams || loadingCreateTicket}
                    value={
                      tipoOs.find(
                        (item) => item.id === paramsAberturaOs?.tipoOs?.id,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.tipoOs?.id
                    }
                    getOptionLabel={(option) => option?.descricao || ""}
                    onChange={(event, value) => {
                      setParamsAberturaOs((prev) => ({
                        ...prev,
                        tipoOs: {
                          id: value?.id,
                          descricao: value?.descricao,
                        },
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="filled"
                        error={error && !paramsAberturaOs?.tipoOs?.id}
                        helperText={
                          error &&
                          !paramsAberturaOs?.tipoOs?.id &&
                          "Campo obrigatório"
                        }
                        label="Tipo de OS"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={statusOs} // Ex: ["aguardando_agendamento", "finalizado"]
                    disabled={
                      loadingParams ||
                      loadingCreateTicket ||
                      tipoAgendamento === "automatico"
                    }
                    value={
                      statusOs.find(
                        (item) =>
                          item?.trim() === paramsAberturaOs?.statusOs?.trim(),
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) => option === value}
                    // AQUI: Transforma "aguardando_agendamento" em "Aguardando Agendamento" apenas na tela
                    getOptionLabel={(option) => formatarNome(option)}
                    // SOLUÇÃO PARA A LISTA NÃO SUMIR:
                    // Se o texto no campo for a versão formatada do item selecionado, ignora o filtro e mostra tudo.
                    filterOptions={(options, state) => {
                      const displayValue = formatarNome(
                        paramsAberturaOs?.statusOs,
                      );
                      if (state.inputValue === displayValue) {
                        return options;
                      }
                      // Filtra comparando o que foi digitado com o label formatado
                      return options.filter((option) =>
                        formatarNome(option)
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase()),
                      );
                    }}
                    onChange={(event, value) => {
                      setParamsAberturaOs((prev) => ({
                        ...prev,
                        statusOs: value || "",
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="filled"
                        error={error && !paramsAberturaOs?.statusOs}
                        helperText={
                          error &&
                          !paramsAberturaOs?.statusOs &&
                          "Campo obrigatório"
                        }
                        label="Status da OS"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>

              <Grid item xs={6} sm={3} md={3}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={verificationCamposOsAutomatico()?.agenda || []}
                    value={
                      agenda?.find(
                        (item) => item?.id === paramsAberturaOs?.agenda?.id,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) =>
                      option ? `${option?.descricao || ""} ` : ""
                    }
                    onChange={(event, value) => {
                      setParamsAberturaOs((prev) => ({
                        ...prev,
                        agenda: {
                          id: value?.id,
                          descricao: value?.descricao,
                        },
                      }));
                    }}
                    sx={{
                      width: "100%",
                    }}
                    disabled={
                      loadingParams ||
                      verificationCamposOsAutomatico()?.disabledAgenda ||
                      loadingCreateTicket ||
                      loadingAgenda
                    }
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        variant="filled"
                        error={error && !paramsAberturaOs?.agenda?.id}
                        helperText={
                          error &&
                          !paramsAberturaOs?.agenda?.id &&
                          "Campo obrigatório"
                        }
                        {...params}
                        label="Agenda"
                      />
                    )}
                  />
                  {(loadingParams || loadingAgenda) && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    multiple
                    limitTags={3}
                    size="small"
                    options={disponibilidade}
                    disabled={loadingParams || loadingCreateTicket}
                    value={disponibilidadeSelecionada}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option?.descricao || ""}
                    onChange={(event, value) => {
                      setDisponibilidadeSelecionada(value);

                      setParamsAberturaOs((prev) => ({
                        ...prev,

                        disponibilidade: value || [],
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          error &&
                          (paramsAberturaOs?.disponibilidade?.length === 0 ||
                            !paramsAberturaOs?.disponibilidade)
                        }
                        helperText={
                          error &&
                          (paramsAberturaOs?.disponibilidade?.length === 0 ||
                            !paramsAberturaOs?.disponibilidade)
                            ? "Campo obrigatório"
                            : ""
                        }
                        size="small"
                        variant="filled"
                        label="Disponibilidade"
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
              {tipoAgendamento === "manual" ? (
                <>
                  <Grid item xs={6} sm={3} md={3}>
                    <Box sx={styles.boxTextField}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="pt-br"
                      >
                        <DateTimePicker
                          label="Data início"
                          size="small"
                          disabled={loadingParams || loadingCreateTicket}
                          value={startDate}
                          // Define o limite mínimo como "agora"
                          minDateTime={dayjs()}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                            if (newValue && dayjs(newValue).isValid()) {
                              // Mantém sua lógica de sugerir +1h no fim
                              setEndDate(dayjs(newValue).add(1, "hour"));
                            }
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              variant: "filled",
                              // Erro se: vazio OU se a data for válida mas anterior a agora
                              error: !!(
                                (error && !startDate) ||
                                (startDate &&
                                  dayjs(startDate).isBefore(dayjs()))
                              ),
                              helperText:
                                error && !startDate
                                  ? "Campo obrigatório"
                                  : startDate &&
                                      dayjs(startDate).isBefore(dayjs())
                                    ? "A data não pode ser retroativa"
                                    : "",
                            },
                            popper: { placement: "bottom" },
                            day: {
                              sx: {
                                "&.Mui-selected": {
                                  background: theme.palette.gradient.orangeMain,
                                  color: theme.palette.white.main,
                                },
                                "&.Mui-selected:hover": {
                                  background: theme.palette.gradient.orangeMain,
                                },
                              },
                            },
                          }}
                        />
                        {loadingParams && (
                          <LinearProgress sx={styles.linearProgres} />
                        )}
                      </LocalizationProvider>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={3} md={3}>
                    <Box sx={styles.boxTextField}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="pt-br"
                      >
                        <DateTimePicker
                          label="Data fim"
                          size="small"
                          value={endDate}
                          onChange={(newValue) => setEndDate(newValue)}
                          disabled={loadingParams || loadingCreateTicket}
                          // Define o limite mínimo visual
                          minDateTime={
                            startDate && dayjs(startDate).isValid()
                              ? dayjs(startDate)
                              : undefined
                          }
                          // Define o limite máximo visual (24h)
                          maxDateTime={
                            startDate && dayjs(startDate).isValid()
                              ? dayjs(startDate).add(24, "hour")
                              : undefined
                          }
                          // ESTA É A CORREÇÃO: Desabilita horários específicos
                          shouldDisableTime={(value, view) => {
                            if (!startDate || !value) return false;

                            // Se a data escolhida for igual à data de início,
                            // desabilitamos tempos menores ou IGUAIS ao início
                            if (dayjs(value).isSame(dayjs(startDate), "day")) {
                              return (
                                value.isBefore(dayjs(startDate)) ||
                                value.isSame(dayjs(startDate))
                              );
                            }
                            return false;
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              variant: "filled",
                              error: !!(
                                (error && !endDate) ||
                                (endDate &&
                                  startDate &&
                                  (dayjs(endDate).isBefore(dayjs(startDate)) ||
                                    dayjs(endDate).isSame(dayjs(startDate)) ||
                                    dayjs(endDate).isAfter(
                                      dayjs(startDate).add(24, "hour"),
                                    )))
                              ),
                              helperText:
                                error && !endDate
                                  ? "Campo obrigatório"
                                  : endDate &&
                                      startDate &&
                                      (dayjs(endDate).isBefore(
                                        dayjs(startDate),
                                      ) ||
                                        dayjs(endDate).isSame(dayjs(startDate)))
                                    ? "A data fim deve ser posterior à data de início"
                                    : endDate &&
                                        startDate &&
                                        dayjs(endDate).isAfter(
                                          dayjs(startDate).add(24, "hour"),
                                        )
                                      ? "O intervalo não pode ser maior que 24 horas"
                                      : "",
                            },
                            popper: { placement: "bottom" },
                            day: {
                              sx: {
                                "&.Mui-selected": {
                                  background: theme.palette.gradient.orangeMain,
                                  color: theme.palette.white.main,
                                },
                                "&.Mui-selected:hover": {
                                  background: theme.palette.gradient.orangeMain,
                                },
                              },
                            },
                          }}
                        />
                        {loadingParams && (
                          <LinearProgress sx={styles.linearProgres} />
                        )}
                      </LocalizationProvider>
                      {loadingParams && (
                        <LinearProgress sx={styles.linearProgres} />
                      )}
                    </Box>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={6} sm={3} md={3}>
                    <Box sx={styles.boxTextField}>
                      <TextField
                        select
                        label="Data do agendamento"
                        // Agora o value é o objeto completo
                        value={dataSelecionada}
                        disabled={
                          loadingParams ||
                          verificationCamposOsAutomatico()?.disabledData ||
                          loadingAgenda ||
                          loadingData
                        }
                        onChange={handleChangeDataOs}
                        fullWidth
                        variant="filled"
                        size="small"
                        // IMPORTANTE: Controla o que aparece escrito no TextField após selecionar
                        SelectProps={{
                          renderValue: (selected) => {
                            if (!selected || !selected.data) return "";
                            return selected.data.split("-").reverse().join("/");
                          },
                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 250, // Define a altura máxima em pixels (ex: ~5 itens)
                                width: "auto", // Garante que a largura se adapte ou siga o padrão
                              },
                            },
                          },
                        }}
                      >
                        {datasOsAutomatica?.datas &&
                        datasOsAutomatica.datas.length > 0 ? (
                          datasOsAutomatica.datas.map((item) => (
                            // Passamos o objeto 'item' completo no value do MenuItem
                            <MenuItem key={item?.data} value={item}>
                              {item?.data?.split("-")?.reverse().join("/")} (
                              {item?.disponiveis} vagas)
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>
                            Nenhuma data disponível para agendamento
                          </MenuItem>
                        )}
                      </TextField>
                      {(loadingParams || loadingData) && (
                        <LinearProgress sx={styles.linearProgres} />
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={3} md={3}>
                    <Box sx={styles.boxTextField}>
                      <TextField
                        select
                        label="Hora do agendamento"
                        value={horaSelecionada}
                        disabled={
                          loadingParams ||
                          verificationCamposOsAutomatico()?.disabledHorario ||
                          loadingAgenda
                        }
                        onChange={handleChangeHorarioOs}
                        fullWidth
                        variant="filled"
                        size="small"
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 250, // Define a altura máxima em pixels (ex: ~5 itens)
                                width: "auto", // Garante que a largura se adapte ou siga o padrão
                              },
                            },
                          },
                        }}
                      >
                        {dataSelecionada?.horarios?.map((item) => (
                          // Passamos o objeto 'item' completo no value do MenuItem
                          <MenuItem key={item?.data} value={item}>
                            {item?.horario}
                          </MenuItem>
                        ))}
                      </TextField>
                      {(loadingParams || loadingData) && (
                        <LinearProgress sx={styles.linearProgres} />
                      )}
                    </Box>
                  </Grid>
                </>
              )}
              <Grid item xs={6} sm={6} smx={4} md={4} lg={4} xl={4} xxl={4}>
                <Box sx={styles.boxTextField}>
                  <Autocomplete
                    multiple
                    size="small"
                    options={autocompleteOptions}
                    disableCloseOnSelect
                    limitTags={1}
                    ListboxComponent={ListboxComponent}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={(event, reason) => {
                      // Evita que o clique interno feche e abra o componente rapidamente
                      if (reason === "toggleInput") return;
                      setOpen(false);
                    }}
                    disabled={
                      loadingParams ||
                      verificationCamposOsAutomatico()?.disabledTecnicos
                    }
                    value={tecnicosSelecionados}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => {
                      if (!option) return "";
                      return option?.email
                        ? `${option?.name} (${option?.email})`
                        : option?.name;
                    }}
                    renderTags={(value, getTagProps) => {
                      if (value?.length === 0) return null;

                      if (open) {
                        return value.map((option, index) => {
                          const { key, ...tagProps } = getTagProps({ index });
                          const label = option.email
                            ? `${option.name} (${option.email})`
                            : option.name;
                          return (
                            <Chip
                              key={key}
                              label={label}
                              size="small"
                              variant="outlined"
                              {...tagProps}
                              // Garante que o clique no Chip (exceto no X) abra a lista se necessário
                              style={{
                                ...tagProps.style,
                                pointerEvents: "auto",
                              }}
                            />
                          );
                        });
                      }

                      const firstItemLabel = value?.[0]?.email
                        ? `${value?.[0]?.name} (${value?.[0]?.email})`
                        : value?.[0]?.name;
                      const remainder = value.length - 1;

                      return (
                        <span
                          style={{
                            fontSize: "14px",
                            paddingLeft: "8px",
                            pointerEvents: "none", // O clique atravessa o texto resumido
                            display: "inline-block",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {firstItemLabel}{" "}
                          {remainder > 0 ? `+${remainder}` : ""}
                        </span>
                      );
                    }}
                    onChange={(event, value) => {
                      const clickedSelectAll = value.some(
                        (option) => option.isSelectAll,
                      );
                      let updatedValue = [];
                      if (clickedSelectAll) {
                        updatedValue = allSelected ? [] : [...optionsOriginal];
                      } else {
                        updatedValue = value?.filter(
                          (option) => !option.isSelectAll,
                        );
                      }

                      setTecnicosSelecionados(updatedValue);
                      setParamsAberturaOs((prev) => ({
                        ...prev,
                        tecnicos: updatedValue,
                      }));
                    }}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...otherProps } = props;

                      if (option.isSelectAll) {
                        return (
                          <div
                            key={option.id}
                            {...otherProps}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            <li
                              {...otherProps}
                              style={{ fontWeight: "bold", width: "100%" }}
                            >
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={allSelected}
                              />
                              {option.name}
                            </li>
                            <Divider style={{ width: "100%" }} />
                          </div>
                        );
                      }

                      return (
                        <li {...props} key={option.id}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.email
                            ? `${option.name} (${option.email})`
                            : option.name}
                        </li>
                      );
                    }}
                    // 2. AJUSTE DE CSS NO INPUT WRAPPER:
                    sx={{
                      width: "100%",
                      "& .MuiFilledInput-root": {
                        cursor: "pointer", // Mostra a mãozinha indicando que toda a área é clicável
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          error &&
                          (paramsAberturaOs?.tecnicos?.length === 0 ||
                            !paramsAberturaOs?.tecnicos)
                        }
                        helperText={
                          error &&
                          (paramsAberturaOs?.tecnicos?.length === 0 ||
                            !paramsAberturaOs?.tecnicos) &&
                          "Campo obrigatório"
                        }
                        size="small"
                        variant="filled"
                        label="Técnicos"
                        inputProps={{
                          ...params.inputProps,
                          // Evita que cliques erráticos no input fechem o menu virtualizado de forma brusca
                          readOnly: false,
                        }}
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>
              <Grid item xs={6} sm={2} smx={2} md={2} lg={2} xl={2} xxl={2}>
                <Box sx={styles.boxTextField}>
                  <VirtualizedAutocomplete
                    size="small"
                    options={prioridade}
                    value={
                      prioridade?.find(
                        (item) =>
                          item?.id ===
                          paramsAberturaOs?.prioridade?.id_prioridade,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                    getOptionLabel={(option) =>
                      option?.prefixo ? formatarNome(option.prefixo) : ""
                    }
                    filterOptions={(options, state) => {
                      const displayValue = formatarNome(
                        paramsAberturaOs?.prioridade?.prefixo,
                      );

                      if (state.inputValue === displayValue) {
                        return options;
                      }

                      return options.filter((option) =>
                        formatarNome(option.prefixo)
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase()),
                      );
                    }}
                    disabled={loadingParams || loadingCreateTicket}
                    onChange={(event, value) => {
                      setParamsAberturaOs((prev) => ({
                        ...prev,
                        prioridade: value
                          ? {
                              id_prioridade: value.id,
                              prefixo: value.prefixo,
                              descricao: value.descricao,
                            }
                          : { id_prioridade: "", prefixo: "" },
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="filled"
                        label="Prioridade"
                        // VALIDAÇÃO: Verifica se o erro global está ativo e se não há ID selecionado
                        error={
                          error && !paramsAberturaOs?.prioridade?.id_prioridade
                        }
                        helperText={
                          error && !paramsAberturaOs?.prioridade?.id_prioridade
                            ? "Campo obrigatório"
                            : ""
                        }
                      />
                    )}
                  />
                  {loadingParams && (
                    <LinearProgress sx={styles.linearProgres} />
                  )}
                </Box>
              </Grid>

              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <MentionTextField
                  typeMetion="os"
                  value={paramsAberturaOs?.descricaoAbertura || ""}
                  onChange={(value) =>
                    setParamsAberturaOs((prev) => ({
                      ...prev,
                      descricaoAbertura: value,
                    }))
                  }
                  label="Descrição de abertura da OS"
                  variant="filled"
                  InputProps={{
                    inputComponent: "textarea",
                  }}
                  /*   disabled={loadingCreateTicket || loadingParams} */
                  error={
                    error &&
                    (!paramsAberturaOs?.descricaoAbertura ||
                      paramsAberturaOs?.descricaoAbertura.length < 10)
                  }
                  helperText={
                    (error &&
                      !paramsAberturaOs?.descricaoAbertura &&
                      "Campo obrigatório") ||
                    (error &&
                      paramsAberturaOs?.descricaoAbertura.length > 0 &&
                      paramsAberturaOs?.descricaoAbertura.length < 10 &&
                      "A descrição deve ter no mínimo 10 caracteres")
                  }
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      paddingTop: "25px",
                      paddingRight: "5px",
                      paddingBottom: "5px",
                    },
                    "& textarea": {
                      resize: "vertical",
                      minHeight: "80px",
                      padding: "10px 12px",
                    },
                  }}
                />
              </Grid>
            </>
          )}
          {isAddAnexo && (
            <>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Divider />
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AttachFileOutlined
                    sx={{ color: theme.palette.primary.main }}
                  />
                  <Typography sx={{ fontWeight: "bold" }}>Anexos</Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                <Box
                  sx={{
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {isAddAnexo && (
                    <FileDropzone
                      files={files}
                      dragActive={dragActive}
                      setDragActive={setDragActive}
                      inputId="fileInputEditTicket"
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      onFileChange={handleFileChange}
                      onRemoveFile={handleRemoveFile}
                    />
                  )}
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Paper>
  );
}
